import { faSliders } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Slider } from '@mui/material';
import { useState } from 'react';

import './styles.scss';

import { Dropdown } from '../../../../../components/dropdown/dropdown';
import usePersistentState from '../../../../../providers/use-persistent-state';

const markValues = [
  -75, -50, -25, -20, -15, -10, -5, -2, -1, -0.5, 0, 0.5, 1, 2, 5, 10, 15, 20, 25, 50, 75, 100, 125,
  150,
];

const markValuesShow = [-75, 150];

const marks = markValues.map((v: number, index: number) => ({
  value: index,

  label: (
    <div className="slider-label">
      <div className="tick" />
      <span>{markValuesShow.includes(v) && `${v.toFixed(1).replace('.', ',')}%`}</span>
    </div>
  ),
}));

interface Iprops {
  setSlider: (val: any) => void;
}

const STATE_PATH = ['RISK_FILTERS'];
const SLIDER_INITIAL_VALUE = 5;
const MARK_VALUES_LENGTH = markValues.length - 1;

const ViewSettings = ({ setSlider }: Iprops) => {
  const [open, setOpen] = useState(false);
  const [slider, setSliderValue] = usePersistentState(STATE_PATH, 'sliderViewSettingsValue', [
    SLIDER_INITIAL_VALUE,
    MARK_VALUES_LENGTH,
  ]);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setSliderValue(newValue as number[]);

    setSlider((newValue as number[]).map((v) => markValues[v]));
  };

  return (
    <div className="view-settings">
      <Button
        className="view-settings-button"
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      >
        <FontAwesomeIcon icon={faSliders} />

        <span>View Settings</span>
      </Button>
      <Dropdown isOpen={open} setIsOpen={setOpen} classNames="dropdown">
        <div className="menu-container">
          <span className="slider-title">Shock visualization</span>
          <div className="view-slider">
            <Slider
              value={slider}
              onChange={handleChange}
              step={null}
              marks={marks}
              min={0}
              max={markValues.length - 1}
              disableSwap
            />
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default ViewSettings;
